import { render, staticRenderFns } from "./ReapresentacaoTitulo.vue?vue&type=template&id=5fd35774"
import script from "./ReapresentacaoTitulo.vue?vue&type=script&lang=js"
export * from "./ReapresentacaoTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd35774')) {
      api.createRecord('5fd35774', component.options)
    } else {
      api.reload('5fd35774', component.options)
    }
    module.hot.accept("./ReapresentacaoTitulo.vue?vue&type=template&id=5fd35774", function () {
      api.rerender('5fd35774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/ReapresentacaoTitulo.vue"
export default component.exports